/**
 * @generated SignedSource<<ede0b9cbd778d076feb961d35dc2a3bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LogOutMutation$variables = Record<PropertyKey, never>;
export type LogOutMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type LogOutMutation = {
  response: LogOutMutation$data;
  variables: LogOutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LogOutMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": null,
        "concreteType": "LogOutPayload",
        "kind": "LinkedField",
        "name": "logOut",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LogOutMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": null,
        "concreteType": "LogOutPayload",
        "kind": "LinkedField",
        "name": "logOut",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c4dcd00dde5bc3c7d0e36b3debfe3b1",
    "id": null,
    "metadata": {},
    "name": "LogOutMutation",
    "operationKind": "mutation",
    "text": "mutation LogOutMutation {\n  responsePayload: logOut {\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f75de9df55ea50c29307f2a9825b923a";

export default node;
